var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthyCookingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 23 1-1 1 1m5 0 1-1 1 1m5 0 1-1 1 1M1 5h22M8 5V3a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-2 0v4m3-4v6M3 16V7a2 2 0 0 0-2-2h22a2 2 0 0 0-2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyCookingInactive);
export default __webpack_public_path__ + "static/media/healthy-cooking-inactive.fe5d4b5359dd0c4acc00570348f704ae.svg";
export { ForwardRef as ReactComponent };